import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import LoginPage from './pages/LoginPage'
import MfaPage from './pages/MfaPage'
import MfaSetupPage from './pages/MfaSetupPage'
import ResetPasswordPage from './pages/ResetPasswordPage'

export const AUTH_ROUTES: RouteObject[] = [
  {
    path: '/auth/login',
    element: (
      <>
        <AppHelmet title='Login' />
        <LoginPage />
      </>
    ),
  },
  {
    path: '/auth/login/:hash',
    element: (
      <>
        <AppHelmet title='Login' />
        <LoginPage />
      </>
    ),
  },
  {
    path: '/auth/mfa-setup',
    element: (
      <>
        <AppHelmet title='Scan QR MFA authenticator' />
        <MfaSetupPage />
      </>
    ),
  },
  {
    path: '/auth/mfa',
    element: (
      <>
        <AppHelmet title='Enter OTP' />
        <MfaPage />
      </>
    ),
  },
  {
    path: '/auth/forgot-password',
    element: (
      <>
        <AppHelmet title='Forgot Password' />
        <ForgotPasswordPage />
      </>
    ),
  },
  {
    path: '/auth/reset-password',
    element: (
      <>
        <AppHelmet title='Reset Password' />
        <ResetPasswordPage />
      </>
    ),
  },
]
